import React, { useEffect, useState, useLayoutEffect, useRef } from 'react';
import * as services from '@services/index';
import { useHistory } from 'react-router-dom';
import { ILives, ICalendars } from '@schemas/video';
import { getTargetUrl } from '@utils/url';
import { openOrDownloadUrl } from '@/utils/open-or-download-url';
import { className, isInYoda, sendClick } from '@/utils/helpers';
import IconFont from '@/components/Iconfont';
import { cacheHandler } from '@/services/videos';
import LiveCard from '../../components/LiveCard';
import CalendarCard from '../../components/CalendarCard';
import styles from './index.module.scss';

const LiveColumn = (props) => {
  const [lives, setLives] = useState<ILives>([]);
  // 这里都没有 set 了
  const [calendars, setCalendars] = useState<ICalendars>([]);

  const livesRef = useRef<HTMLUListElement>(null);

  const history = useHistory();

  const handleMore = () => {
    sendClick('LIVE_MORE_BUTTON');

    const url = getTargetUrl(
      `${window.location.origin}/lives?layoutType=4&enableWK=1&hyId=healthy-channel`
    );
    if (isInYoda) {
      openOrDownloadUrl(url);
    } else {
      history.push('/lives');
    }
  };

  useLayoutEffect(() => {
    props.initTabPosition && props.initTabPosition();
  }, [lives]);

  const getLives = async () => {
    try {
      const data = await services.videos.getLiveColumn();
      setLives(data);
    } catch (error) {
      //
    }
  };

  useEffect(() => {
    const data = cacheHandler.getLiveColumn.get();
    if (data) {
      setLives(data);
    }
    getLives();
  }, []);

  return (
    <>
      <section className={styles['live-column']}>
        {(!!lives.length || !!calendars.length) && (
          <div className={styles['book-live']}>
            <h1>健康直播</h1>
            <button type="button" onClick={handleMore}>
              <IconFont icon="common_base_next_24" />
            </button>
          </div>
        )}
        {/* 肯定不会有数据 */}
        {/* {!!calendars.length && (
          <ul className={styles['live-list']}>
            {calendars.slice(0, 2).map((live, index) => (
              <CalendarCard index={index} live={live} key={index} />
            ))}
          </ul>
        )} */}
        {!!lives.length && (
          <ul
            ref={livesRef}
            className={className(
              styles['lives-wrapper'],
              styles['live-cards'],
              lives.length > 3 ? styles.pdr19 : ''
            )}
          >
            {lives.slice(0, 8).map((live, index) => (
              <LiveCard
                key={live.link + index}
                liveIndex={index + 1}
                live={live}
              />
            ))}
            {lives.length > 3 && (
              <div
                aria-hidden
                className={styles['label-more-wrapper']}
                onClick={handleMore}
              >
                <IconFont icon="common_base_spread_24" />
                <div className={styles.label}>查看更多</div>
              </div>
            )}
          </ul>
        )}
      </section>
    </>
  );
};

export default LiveColumn;
